import React from 'react'
import { Logo2025, LinkButton } from 'components/atoms'
import { Heading } from 'grommet'
import PropTypes from 'prop-types'

export const Logo2025Button = ({}) => {
    return (
        <LinkButton
            as={'button'}
            plain
            icon={<Logo2025 />}
            to={'/'}
        />
    )
}

Logo2025Button.propTypes = {}

Logo2025Button.defaultProps = {}
